import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import UserService from '../utils/UserService';

const PROMPT_DISMISS_DURATION = 60 * 60 * 1000 * 3; // 3 hours in milliseconds

export const useTimeSlotPrompt = () => {
  const [shouldShowPrompt, setShouldShowPrompt] = useState(false);
  const userInfo = useSelector((state) => state?.user?.userInfo);
  const location = useLocation();

  const isBookingPage = location.pathname === '/bookings';

  useEffect(() => {
    const checkPromptVisibility = () => {
      // Only show for founders who haven't set a time slot
      if (userInfo?.userTypeId === 1 && !userInfo?.hasSlot && !isBookingPage) {
        const lastDismissed = UserService.getTimeSlotPromptDismissed();

        if (!lastDismissed) {
          setShouldShowPrompt(true);
        } else {
          const timeSinceLastDismissed = Date.now() - parseInt(lastDismissed);
          if (timeSinceLastDismissed >= PROMPT_DISMISS_DURATION) {
            setShouldShowPrompt(true);
          }
        }
      } else {
        setShouldShowPrompt(false);
      }
    };

    checkPromptVisibility();
  }, [userInfo, location.pathname]);

  return {
    shouldShowPrompt,
    setShouldShowPrompt,
  };
};
